import Immutable from 'immutable';
import uniqBy from 'lodash/uniqBy';
import FontTypes from '~/constants/types/FontTypes';
import {mapFontToLicensedTerm} from '~/constants/FontCategoryConstants.js';

function initialState() {
  return Immutable.Map({
    categories: Immutable.Map(),
    fonts: Immutable.Map(),
    fontAutofillData: [],
    // fontSearchHistory will store a subset of Font information (displayName & name)
    fontSearchHistory: Immutable.List(),
    isFontClickedFromDropdown: false,
    previousFontCategory: '',
    scrollToFont: false
  });
}

export default function font(state = initialState(), action) {
  switch (action.type) {
    case FontTypes.CATEGORY_LOADED: {
      const {category, resource} = action.payload;
      return state.setIn(['fonts', category], resource);
    }

    case FontTypes.CATEGORIES_LOADED: {
      const {resource} = action.payload;
      return state.set('categories', resource);
    }

    case FontTypes.FONT_AUTOFILL_DATA_LOADED: {
      let autofillData = action.payload;
      autofillData = autofillData.map(item => {
        const name = item.fontCategory || item.displayName;
        const mappedName = mapFontToLicensedTerm(name);
        Object.prototype.hasOwnProperty.call(item, 'fontCategory')
          ? (item.fontCategory = mappedName)
          : (item.displayName = mappedName);
        return item;
      });
      return state.set('fontAutofillData', autofillData);
    }

    case FontTypes.FONT_IS_CLICKED_FROM_DROPDOWN: {
      return state.set('isFontClickedFromDropdown', action.payload);
    }

    case FontTypes.LOAD_FONT_SEARCH_HISTORY: {
      const icons = uniqBy(action.payload, icon => icon.name);
      // fontSearchHistory will store a subset of Font information (displayName & name)
      icons.forEach(icon => {
        state = state.update('fontSearchHistory', fontSearchHistory =>
          fontSearchHistory.push(icon)
        );
      });

      return state;
    }

    case FontTypes.SET_SCROLL_TO_FONT: {
      return state.set('scrollToFont', true);
    }

    case FontTypes.UPDATE_FONT_SEARCH_HISTORY: {
      // fontSearchHistory will store a subset of Font information (displayName & name)
      return state.update('fontSearchHistory', fontSearchHistory => {
        return fontSearchHistory
          .filter(v => v.name !== action.payload.name)
          .unshift(action.payload);
      });
    }

    case FontTypes.UPDATE_PREVIOUS_CATEGORY: {
      const {category} = action.payload;
      return state.set('previousFontCategory', category);
    }

    default:
      return state;
  }
}
